import React, { useState, useEffect } from "react";
import "../Products/Products.css";
// import Item from "../Item/Item";
import all_product from "../Assets/all_products";
// import { Link } from "react-router-dom";
import $ from "jquery";
// import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";

function Products() {
  const [current, setCurrent] = useState(0);
  const [btnShow, setBtnShow] = useState(false);
  const [displayedData, setDisplayedData] = useState(all_product);
  const [visibleItemCount] = useState(0);
  // console.log(displayedData);

  // const nextSlide = () => {
  //   setCurrent(current === displayedData.length - 1 ? 0 : current + 1);
  // };
  // const prevSlide = () => {
  //   setCurrent(current === 0 ? displayedData.length - 1 : current - 1);
  // };

  useEffect(() => {
    let slider = setInterval(() => {
      setCurrent(current === displayedData.length - 1 ? 0 : current + 1);
    }, 3000);
    return () => clearInterval(slider);
  });

  useEffect(() => {
    if (window.location.pathname === "/product") {
      setBtnShow(true);
    } else {
      setDisplayedData(all_product.slice(0, visibleItemCount + 12));
    }
  }, []);
  const tableOne = () => {
    $("#data-tab-1")
      .find("th")
      .click(function () {
        //	  		alert('th clicked')
        var i = $(this).index();
        $(this).addClass("selected").siblings().removeClass();
        $("#data-box-1").children().hide();
        $("#data-box-1").children().eq(i).show();
      });
  };
  const tableTwo = () => {
    $("#data-tab-2")
      .find("th")
      .click(function () {
        //	  		alert('th clicked')
        var i = $(this).index();
        $(this).addClass("selected").siblings().removeClass();
        $("#data-box-2").children().hide();
        $("#data-box-2").children().eq(i).show();
      });
    $(".hidden-nav").click(function () {
      $("#header-nav").slideToggle();
    });
  };
  return (
    <>
      <div className="product">
        {
          <div className="product-thumb">
              <div className="thumbnail">
                {all_product.map((Item, index) => {
                  return (
                    <div
                      className={current === index ? "slide active" : "slide"}
                      key={index}
                    >
                      {index === current && (
                        <div>
                          <div className="current-thumb">
                            <img src={Item.image} alt="" className="thumb" />
                            <div className="current-thumb-info">
                              <p className="current-thumb-product-name">
                                {Item.name}
                              </p>
                              <p>{Item.description}</p>
                              <p>{Item.size}</p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="slideshowDots">
                {all_product.map((_, idx) => (
                  <div
                    key={idx}
                    className={`slideshowDot${
                      current === idx ? " active" : ""
                    }`}
                    onClick={() => setCurrent(idx)}
                  ></div>
                ))}
              </div>
          </div>
        }
        {btnShow && (
          <div class="approved-product">
            <span>
              "State of the art WHO-GMP, ISO 9001:2008 and NPCB, PIC/S Malaysia
              approved manufacturing facility".
            </span>
          </div>
        )}
        {btnShow && (
          <div className="product-table">

          <article class="clearfix-a">
            <h2 class="data-title">
              Single <span>Products</span>
            </h2>
            <br />
            <div>
              <table
                id="data-tab-1"
                class="data-tab">
                <tr onClick={tableOne}>
                  <th class="selected" style={{padding:"4px"}}>
                    A. Bronchodilators
                    <br />
                    (Anti-cholinergic)
                  </th>
                  <th style={{padding:"4px"}}>
                    B. Bronchodilators
                    <br />
                    (&szlig;-Agonist)
                  </th>
                  <th style={{padding:"4px"}}>
                    C. Anti inflammatory
                    <br />
                    Agents Corticosteroids
                  </th>
                </tr>
              </table>
            </div>
            <div id="data-box-1">
              <table
                class="data-table"
              >
                <tr>
                  <th>Generic Name</th>
                  <th >Strength</th>
                  <th >Metered Doses</th>
                </tr>
                <tr>
                  <td>Tiotropium Bromide Inhaler</td>
                  <td>9 mcg / dose</td>
                  <td>60/120 MD</td>
                </tr>
                <tr>
                  <td>Ipratropium Bromide Inhaler</td>
                  <td>20 mcg / dose</td>
                  <td>200 MD</td>
                </tr>
              </table>

              <table
                class="data-table"
                style={{ display: "none" }}
                >
                <tr>
                  <th >Generic Name</th>
                  <th >Strength</th>
                  <th >Metered Doses</th>
                </tr>
                <tr>
                  <td>Salbutamol Inhaler (Alcoholic)</td>
                  <td>100 mcg / dose</td>
                  <td>200 MD</td>
                </tr>
                <tr>
                  <td>Salbutamol Inhaler (Non-alcoholic)</td>
                  <td>100 mcg / dose</td>
                  <td>200 MD</td>
                </tr>
                <tr>
                  <td colspan="3" style={{height:"10px"}}></td>
                </tr>
                <tr>
                  <td>Levosalbutamol Inhaler</td>
                  <td>50 mcg / dose</td>
                  <td>200 MD</td>
                </tr>
              </table>

              <table
                class="data-table"
                style={{ display: "none" }}
                >
                <tr>
                  <th >Generic Name</th>
                  <th >Strength</th>
                  <th >Metered Doses</th>
                </tr>
                <tr>
                  <td>Budesonide Inhaler</td>
                  <td>100 mcg / dose</td>
                  <td>200 MD</td>
                </tr>
                <tr>
                  <td>Budesonide Inhaler</td>
                  <td>200 mcg / dose</td>
                  <td>200 MD</td>
                </tr>
                <tr>
                  <td colspan="3" style={{height:"10px"}}> </td>
                </tr>
                <tr>
                  <td>Fluticasone Propionate Inhaler</td>
                  <td>50 mcg / dose</td>
                  <td>120 MD</td>
                </tr>
                <tr>
                  <td>Fluticasone Propionate Inhaler</td>
                  <td>125 mcg / dose</td>
                  <td>120 MD</td>
                </tr>
                <tr>
                  <td>Fluticasone Propionate Inhaler</td>
                  <td>250 mcg / dose</td>
                  <td>120 MD</td>
                </tr>
                <tr>
                  <td colspan="3" style={{height:"10px"}}> </td>
                </tr>
                <tr>
                  <td>Beclometasone Dipropionate Inhaler</td>
                  <td>50 mcg / dose</td>
                  <td>200 MD</td>
                </tr>
                <tr>
                  <td>Beclometasone Dipropionate Inhaler</td>
                  <td>100 mcg / dose</td>
                  <td>200 MD</td>
                </tr>
                <tr>
                  <td>Beclometasone Dipropionate Inhaler</td>
                  <td>250 mcg / dose</td>
                  <td>200 MD</td>
                </tr>
              </table>
            </div>
            
          </article>
          <br />
          <article class="clearfix-a">
            <h2 class="data-title">
              Combination <span>Products</span>
            </h2>
            <br />
            <div>
              <table
                id="data-tab-2"
                class="data-tab"
              >
                <tr onClick={tableTwo}>
                  <th class="selected" style={{padding:"4px"}}>
                    A. Anti-cholinergic + <br />
                    Bronchodilators
                  </th>
                  <th style={{padding:"4px"}}>
                    B. Bronchodilators + <br />
                    Corticosteroids
                  </th>
                </tr>
              </table>
            </div>
            <div id="data-box-2">
              <table
                class="data-table"
              >
                <tr>
                  <th >Generic Name</th>
                  <th >Strength</th>
                  <th >Metered Doses</th>
                </tr>
                <tr>
                  <td>Ipratropium & Salbutamol Inhaler</td>
                  <td>20 + 100 mcg / dose</td>
                  <td>200 MD</td>
                </tr>
                <tr>
                  <td colspan="3" style={{height:"10px"}}> </td>
                </tr>
                <tr>
                  <td>Tiotropium & Formoterol Inhaler</td>
                  <td>9 + 6 mcg / dose</td>
                  <td>60 / 120 MD</td>
                </tr>
              </table>

              <table
                class="data-table"
                style={{ display: "none" }}
                >
                <tr>
                  <th >Generic Name</th>
                  <th >Strength</th>
                  <th >Metered Doses</th>
                </tr>
                <tr>
                  <td>Salmeterol + Fluticasone Inhaler</td>
                  <td>25 + 50 mcg / dose</td>
                  <td>60 / 120 MD</td>
                </tr>
                <tr>
                  <td>Salmeterol + Fluticasone Inhaler</td>
                  <td>25 + 125 mcg / dose</td>
                  <td>60 / 120 MD</td>
                </tr>
                <tr>
                  <td>Salmeterol + Fluticasone Inhaler</td>
                  <td>25 + 250 mcg / dose</td>
                  <td>60 /120 MD</td>
                </tr>
                <tr>
                  <td colspan="3" style={{height:"10px"}}> </td>
                </tr>
                <tr>
                  <td>Formoterol + Budesonide Inhaler</td>
                  <td>6 + 100 mcg / dose</td>
                  <td>60 / 120 MD</td>
                </tr>
                <tr>
                  <td>Formoterol + Budesonide Inhaler</td>
                  <td>6 + 200 mcg / dose</td>
                  <td>60 / 120 MD</td>
                </tr>
                <tr>
                  <td>Formoterol + Budesonide Inhaler</td>
                  <td>6 + 400 mcg / dose</td>
                  <td>60 / 120 MD</td>
                </tr>
                <tr>
                  <td colspan="3" style={{height:"10px"}}> </td>
                </tr>
                <tr>
                  <td>Beclometasone + Salbutamol Inhaler</td>
                  <td>50 + 100 mcg / dose</td>
                  <td>200 MD</td>
                </tr>
                <tr>
                  <td colspan="3" style={{height:"10px"}}> </td>
                </tr>
                <tr>
                  <td>Formoterol + Fluticasone Inhaler</td>
                  <td>6 + 125 mcg / dose</td>
                  <td>120 MD</td>
                </tr>
                <tr>
                  <td>Formoterol + Fluticasone Inhaler</td>
                  <td>6 + 250 mcg / dose</td>
                  <td>120 MD</td>
                </tr>
              </table>
            </div>
          </article>
          
        </div>
          // <div className="product-table">
          //   <article class="clearfix-a table-1">
          //     <h2 class="data-title">
          //       Single <span>Products</span>
          //     </h2>
          //     <br />
          //     <div className="table-1-scroll"></div>
          //     <div>
          //       <table
          //         id="data-tab-1"
          //         class="data-tab "
          //         width="100%"
          //         border="0"
          //         cellspacing="0"
          //         cellpadding="15"
          //       >
          //         <tr onClick={tableOne} className="product-tab-1">
          //           <th class="selected">
          //             A. Bronchodilators
          //             <br />
          //             (Anti-cholinergic)
          //           </th>
          //           <th>
          //             B. Bronchodilators
          //             <br />
          //             (&szlig;-Agonist)
          //           </th>
          //           <th>
          //             C. Anti inflammatory
          //             <br />
          //             Agents Corticosteroids
          //           </th>
          //         </tr>
          //       </table>
          //     </div>
          //     <div id="data-box-1">
          //       <table
          //         class="data-table top-detail-table"
          //         width="100%"
          //         border="0"
          //         cellspacing="0"
          //         cellpadding="15"
          //       >
          //         <tr>
          //           <th width="50%">Generic Name</th>
          //           <th width="30%">Strength</th>
          //           <th width="20%">Metered Doses</th>
          //         </tr>
          //         <tr>
          //           <td>Tiotropium Bromide Inhaler</td>
          //           <td>9 mcg / dose</td>
          //           <td>60 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Tiotropium Bromide Inhaler</td>
          //           <td>9 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //       </table>

          //       <table
          //         class="data-table top-detail-table"
          //         width="100%"
          //         border="0"
          //         cellspacing="0"
          //         cellpadding="15"
          //         style={{ display: "none" }}
          //       >
          //         <tr>
          //           <th width="50%">Generic Name</th>
          //           <th width="30%">Strength</th>
          //           <th width="20%">Metered Doses</th>
          //         </tr>
          //         <tr>
          //           <td>Salbutamol Inhaler (Alcoholic)</td>
          //           <td>100 mcg / dose</td>
          //           <td>200 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Salbutamol Inhaler (Non-alcoholic)</td>
          //           <td>100 mcg / dose</td>
          //           <td>200 MD</td>
          //         </tr>
          //         <tr>
          //           <td colspan="3"></td>
          //         </tr>
          //         <tr>
          //           <td>Levosalbutamol Inhaler</td>
          //           <td>50 mcg / dose</td>
          //           <td>200 MD</td>
          //         </tr>
          //       </table>

          //       <table
          //         class="data-table top-detail-table"
          //         width="100%"
          //         border="0"
          //         cellspacing="0"
          //         cellpadding="15"
          //         style={{ display: "none" }}
          //       >
          //         <tr>
          //           <th width="50%">Generic Name</th>
          //           <th width="30%">Strength</th>
          //           <th width="20%">Metered Doses</th>
          //         </tr>
          //         <tr>
          //           <td>Budesonide Inhaler</td>
          //           <td>100 mcg / dose</td>
          //           <td>200 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Budesonide Inhaler</td>
          //           <td>200 mcg / dose</td>
          //           <td>200 MD</td>
          //         </tr>
          //         <tr>
          //           <td colspan="3"></td>
          //         </tr>
          //         <tr>
          //           <td>Fluticasone Propionate Inhaler</td>
          //           <td>50 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Fluticasone Propionate Inhaler</td>
          //           <td>125 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Fluticasone Propionate Inhaler</td>
          //           <td>250 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //         <tr>
          //           <td colspan="3"></td>
          //         </tr>
          //         <tr>
          //           <td>Beclometasone Dipropionate Inhaler</td>
          //           <td>50 mcg / dose</td>
          //           <td>200 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Beclometasone Dipropionate Inhaler</td>
          //           <td>100 mcg / dose</td>
          //           <td>200 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Beclometasone Dipropionate Inhaler</td>
          //           <td>250 mcg / dose</td>
          //           <td>200 MD</td>
          //         </tr>
          //       </table>
          //     </div>
          //   </article>
          //   <br />
          //   <article class="clearfix-a table-1">
          //     <h2 class="data-title">
          //       Combination <span>Products</span>
          //     </h2>
          //     <br />
          //     <div>
          //       <table
          //         id="data-tab-2"
          //         class="data-tab"
          //         width="100%"
          //         border="0"
          //         cellspacing="0"
          //         cellpadding="15"
          //       >
          //         <tr onClick={tableTwo}>
          //           <th width="50%" class="selected">
          //             A. Anti-cholinergic +<br />
          //             Bronchodilators
          //           </th>
          //           <th width="50%">
          //             B. Bronchodilators +<br />
          //             Corticosteroids
          //           </th>
          //         </tr>
          //       </table>
          //     </div>
          //     <div id="data-box-2">
          //       <table
          //         class="data-table"
          //         width="100%"
          //         border="0"
          //         cellspacing="0"
          //         cellpadding="15"
          //       >
          //         <tr>
          //           <th width="50%">Generic Name</th>
          //           <th width="30%">Strength</th>
          //           <th width="20%">Metered Doses</th>
          //         </tr>
          //         <tr>
          //           <td>Ipratropium & Salbutamol Inhaler</td>
          //           <td>20 + 100 mcg / dose</td>
          //           <td>200 MD</td>
          //         </tr>
          //         <tr>
          //           <td colspan="3"></td>
          //         </tr>
          //         <tr>
          //           <td>Tiotropium & Formoterol Inhaler</td>
          //           <td>9 + 6 mcg / dose</td>
          //           <td>60 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Tiotropium & Formoterol Inhaler</td>
          //           <td>9 + 6 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //       </table>

          //       <table
          //         class="data-table"
          //         width="100%"
          //         border="0"
          //         cellspacing="0"
          //         cellpadding="15"
          //         style={{ display: "none" }}
          //       >
          //         <tr>
          //           <th width="50%">Generic Name</th>
          //           <th width="30%">Strength</th>
          //           <th width="20%">Metered Doses</th>
          //         </tr>
          //         <tr>
          //           <td>Salmeterol + Fluticasone Inhaler</td>
          //           <td>25 + 50 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Salmeterol + Fluticasone Inhaler</td>
          //           <td>25 + 125 mcg / dose</td>
          //           <td>60 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Salmeterol + Fluticasone Inhaler</td>
          //           <td>25 + 125 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Salmeterol + Fluticasone Inhaler</td>
          //           <td>25 + 250 mcg / dose</td>
          //           <td>60 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Salmeterol + Fluticasone Inhaler</td>
          //           <td>25 + 250 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //         <tr>
          //           <td colspan="3"></td>
          //         </tr>
          //         <tr>
          //           <td>Formoterol + Budesonide Inhaler</td>
          //           <td>6 + 100 mcg / dose</td>
          //           <td>60 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Formoterol + Budesonide Inhaler</td>
          //           <td>6 + 100 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Formoterol + Budesonide Inhaler</td>
          //           <td>6 + 200 mcg / dose</td>
          //           <td>60 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Formoterol + Budesonide Inhaler</td>
          //           <td>6 + 200 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Formoterol + Budesonide Inhaler</td>
          //           <td>6 + 400 mcg / dose</td>
          //           <td>60 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Formoterol + Budesonide Inhaler</td>
          //           <td>6 + 200 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //         <tr>
          //           <td colspan="3"></td>
          //         </tr>
          //         <tr>
          //           <td>Beclometasone + Salbutamol Inhaler</td>
          //           <td>50 + 100 mcg / dose</td>
          //           <td>200 MD</td>
          //         </tr>
          //         <tr>
          //           <td colspan="3"></td>
          //         </tr>
          //         <tr>
          //           <td>Formoterol + Fluticasone Inhaler</td>
          //           <td>6 + 125 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //         <tr>
          //           <td>Formoterol + Fluticasone Inhaler</td>
          //           <td>6 + 250 mcg / dose</td>
          //           <td>120 MD</td>
          //         </tr>
          //       </table>
          //     </div>
          //   </article>
          // </div>
        )}
      </div>
    </>
  );
}
export default Products;
